module.exports = __webpack_public_path__ + "static/media/v&r.318b5919.jpg";